export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeDeliveryInfo: {
        noticeDeliveryAt: 1234567890123,
        serviceName: "サービス名",
        deliveryTo: ["全配信"],
        deliveryStatus: 1,
        deliveryLocationCount: 141,
        openedLocationCount: 41,
        thumbupLocationCount: 39,
        deliverySpCount: 1200,
        openedSpCount: 722,
        thumbupSpCount: 697
      },
      deliveryContents: {
        title: 'xxxxx',
        body: 'xxxxx',
        attachments: [],
        soundFile: [],
        linkUrl: 'xxxxx',
        question: 'xxxxx',
        answerOptions: [],
        keikaiLevel: 0
      }
    }
  }
}